const initState = {
    authError: null,
    passwordReset: false,
    superAdmin: null
}

const authReducer = (state = initState, action) => {
    switch(action.type) {
        case 'LOGIN_ERROR':
            return {
                ...state,
                authError: 'Login failed',
            }
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                authError: null,
            }
        case 'IS_SUPER_ADMIN':
            return {
                ...state,
                superAdmin: true
            }
        case 'NOT_SUPER_ADMIN':
            return {
                ...state,
                superAdmin: false
            }
        case 'PASSWORD_RESET_ERROR':
            return {
                ...state,
                authError: 'The email address does not match our records.',
                passwordReset: false
            }
        case 'PASSWORD_RESET_SUCCESS':
            return {
                ...state,
                authError: null,
                passwordReset: true
            }
        case 'SIGNOUT_SUCCESS':
            return {
                authError: null,
                passwordReset: false,
                superAdmin: null
            }
        default:
            return state
    }
}

export default authReducer